import React from "react";
import { Chart2, Lock1, People, UserAdd } from "iconsax-reactjs";
import "./DealerStaff.css";

// What the staff feature will cover, as described in the coming-soon copy.
const PLANNED = [
  { icon: <UserAdd size={18} variant="Linear" />, text: "Add the real estate brokers on your team" },
  { icon: <Chart2 size={18} variant="Linear" />, text: "Track lead performance for each broker" },
  { icon: <Lock1 size={18} variant="Linear" />, text: "Set workspace permissions" },
];

export default function DealerStaff() {
  return (
    <div className="ds-panel">
      <section className="card ds-card" aria-labelledby="ds-title">
        <div className="empty-state ds-intro">
          <span className="empty-state-icon">
            <People size={24} variant="Linear" />
          </span>
          <span className="chip">Coming soon</span>
          <h3 id="ds-title">Staff management</h3>
          <p>
            Manage your team of real estate brokers, track each broker's lead performance and set
            workspace permissions. This feature is in active development.
          </p>
        </div>

        <ul className="ds-planned" aria-label="Planned features">
          {PLANNED.map((item) => (
            <li key={item.text} className="ds-planned-item">
              <span className="ds-planned-icon" aria-hidden="true">
                {item.icon}
              </span>
              <span>{item.text}</span>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
